import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';

import {HttpEventType, HttpErrorResponse} from '@angular/common/http';

import {of} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {FileUploadService} from '../file-upload/remote/file-upload.service';
import { Router, RouterModule } from '@angular/router';
import { UploadDownloadService } from '../file-upload/upload-download.service';
import { ShareService } from 'src/services/share.service';
import { ShareDataService } from 'src/providers/sharedata.service';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
  loading: boolean = false;
  loader: string;
  fileName: string;
  selectedFile: FormData;
    DateNow: string;
  
  constructor(public uploadService: UploadDownloadService, public router: Router, public share: ShareDataService,public dialog: MatDialog) { }
  

  ngOnInit(): void {
    this.date();
  }

  confirmation(title: string) {
    const dialogRef = this.dialog.open(DialogComponent);
    dialogRef.componentInstance.confirmation(title);
    dialogRef.afterClosed().subscribe(result => {
        if (result === 'Ok') {
            this.dialog.closeAll();
        } else {
            return;
        }
    });
  }
  date(): void { this.DateNow = `?${Date.now()}`; }

}
